const initMap = async (general_response) => {
  const mapElement = document.getElementById("map");

  if (!mapElement) return;

  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  const baseUrl = mapElement.getAttribute("data-theme");

  const iconPin = `
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 10 10">
      <circle cx="5" cy="5" r="5" fill="#FB4622"/>
    </svg>
  `;

  const parser = new DOMParser();
  const pinSvg = parser.parseFromString(iconPin, "image/svg+xml").documentElement;

  const iconYoutube = baseUrl + "/assets/img/icon-youtube.svg";

  // Create Map
  let map = new Map(mapElement, {
    zoom: 1,
    center: {
      lat: 45.4832203,
      lng: 9.1794007,
    },
    disableDefaultUI: true,
    gestureHandling: "cooperative",
    mapId: "a353ad82f66d054ccbba5ab9",
  });

  map = iddRsizeMap(map);

  // Global InfoWindow (BEST PRACTICE ⭐)
  const globalInfoWindow = new InfoWindow();

  // Loop data
  if (general_response) {
    general_response.forEach((testimonial) => {

      const testimonialName = `${testimonial.nome} ${testimonial.cognome}`;
      const testimonialLocations = testimonial.locations || [];

      testimonialLocations.forEach((location) => {

        const lat = Number(location?.address?.lat);
        const lng = Number(location?.address?.lng);

        // Validate coordinates
        if (isNaN(lat) || isNaN(lng)) return;

        const pinSvgClone = pinSvg.cloneNode(true);

        const marker = new AdvancedMarkerElement({
          map,
          position: { lat, lng },
          content: pinSvgClone,
          title: testimonialName,
          gmpClickable: true,
        });

        marker.addEventListener("gmp-click", () => {

          const markerContent = `
          <h5 class="map-marker-title">${testimonialName}</h5>
          <p>${location.label || ""}</p>
          ${location.video_url
              ? `<p>
                   <a href="${location.video_url}" target="_blank">
                     <img class="map__info__icon" src="${iconYoutube}">
                   </a>
                 </p>`
              : ""
            }
        `;

          globalInfoWindow.close();
          globalInfoWindow.setContent(markerContent);
          globalInfoWindow.open(map, marker);
        });

      });

    });
  }

};

export default initMap;


/**
 * Resize Map at breakpoints
 */
const iddRsizeMap = (map) => {

  const breakpoints = [
    { query: "(min-width: 576px)", zoom: 1.2 },
    { query: "(min-width: 768px)", zoom: 1.5 },
    { query: "(min-width: 992px)", zoom: 1.8 },
    { query: "(min-width: 1200px)", zoom: 2 },
  ];

  breakpoints.forEach(bp => {
    if (window.matchMedia(bp.query).matches) {
      map.setZoom(bp.zoom);
    }
  });

  return map;
};